<div class="row">
	<div class="col-12">
		<h3>Contract ID: {{contract_id}}</h3>
	</div>
</div>

<div class="row" style="position: relative">
	<div class="loading" *ngIf="loading">
		<div class="spinner-border text-primary" role="status">
			<span class="sr-only">Loading...</span>
		</div>
	</div>
	<div class="col-4" align="left">
		<div *ngIf="!uploading" (dragleave)="onDragLeave($event)" (dragover)="onDragOver($event)" class="dropzone"
			appDnd (fileDropped)="onFileDropped($event)">
			<div>
				<input class="upload" type="file" #fileDropRef id="fileDropRef" multiple
					(change)="onFileDropped($event.target.files)" />
				<h3 class="upload">Drag and drop files here</h3>
				<h3 class="upload">or</h3>
				<button type="button" class="upload btn btn-secondary waves-effect waves-light">Browse</button>
			</div>
		</div>
	</div>

	<div class="col-8">
		<table class="table table-sm">
			<thead>
				<tr>
					<th>#</th>
					<th>File Name</th>
					<th>Download</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let upFile of uploadedFiles; let i = index">
						<td>{{ i + 1 }}</td>
						<td>{{ formatName(upFile.name) }}</td>
						<td>
							<button class="btn btn-primary btn-sm" (click)="downloadFile(upFile.name)">Download</button>
						</td>

						<td>
							<button class="btn btn-danger waves-effect waves-light btn-sm"
								(click)="deleteFile(upFile.name)">
								<i class="ri-delete-bin-line"></i>
							</button>
						</td>
					</tr>
			</tbody>
		</table>
	</div>
</div>
